import React from 'react';
import { NavLink } from 'react-router-dom';
import './NavigationLink.scss';

function handleInActiveClass(isMobile) {
  if (isMobile) return '';
  return 'inactive-page';
}

// TODO: define isMobile state in parent component if needed
export const NavigationLink = ({ to, className, isMobile, children, onClick, isActiveNavLink }) => {
  return (
    <NavLink
      to={isActiveNavLink ? '' : to}
      onClick={onClick}
      className={({ isActive, isPending, isTransitioning }) =>
        [
          'ek-copy-16-regular',
          'text-primary',
          'm-2',
          'd-inline-block',
          'nav-link',
          isMobile ? 'nav-link-mobile' : '',
          className,
          isPending ? 'pending' : '',
          isActive ? 'active-page' : handleInActiveClass(isMobile),
          isTransitioning ? 'transitioning' : ''
        ]
          .filter(Boolean)
          .join(' ')
      }
      style={{
        cursor: isActiveNavLink ? 'default' : 'pointer',
        pointerEvents: isActiveNavLink ? 'none' : 'auto'
      }}>
      {children}
    </NavLink>
  );
};

export default NavigationLink;
